import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Button from '../../../Button';
import ROUTES from '../../../../constants/ROUTES';
import { fetchProjects } from '../../../../redux/slices/project';

import searchIcon from '../../../../assets/SearchGray.svg';
import plusIcon from '../../../../assets/Plus.svg';
import ListIconWhite from '../../../../assets/ListIconWhite.svg';
import noteIcon from '../../../../assets/Note.svg';
import VisibilitySensor from 'react-visibility-sensor';
const ProjectsTab = ({ closeModal }) => {
  const listElement = useRef(null);

  // Sample DATA
  const dispatch = useDispatch();
  const navigation = useNavigate();

  const { projectList, loading } = useSelector((state) => state?.project);

  useEffect(() => {
    dispatch(fetchProjects());
  }, []);

  const handleSelectProject = (selectedProjectId) => {
    closeModal();
    navigation(`${ROUTES.projectDetails}/activity/${selectedProjectId}`);
  };

  return (
    <div className='flex flex-col h-full'>
      <div className='flex flex-col gap-y-2 border-b border-neutral-600 pb-2.5'>
        <Button
          icon={plusIcon}
          title={'New Project'}
          iconStyle={'mr-2'}
          textStyle={'text-sm'}
          buttonStyle={'rounded-lg'}
          handleClick={() => {
            closeModal();
            navigation(ROUTES.newProject);
          }}
        />

        <div className='flex flex-row relative w-full'>
          <Button
            icon={ListIconWhite}
            title={'View all Projects'}
            iconStyle={'mr-2'}
            textStyle={'text-sm'}
            buttonStyle={'rounded-lg w-full'}
            handleClick={() => {
              closeModal();
              navigation(ROUTES.allProjects);
            }}
          />

          <div className='absolute right-0 flex flex-col h-full justify-center mr-2'>
            <button
              className='bg-white/10 hover:bg-white/20 px-[2.5px] py-1 rounded'
              onClick={(e) => {
                e.stopPropagation();
                closeModal();
                navigation(`${ROUTES.allProjects}/goToSearch`);
              }}
            >
              <img src={searchIcon} className='w-[20px]' alt='Search' />
            </button>
          </div>
        </div>
      </div>

      <div className='flex flex-col gap-y-1 h-full overflow-hidden'>
        <span className='text-white font-semibold mt-2'>Recent Projects</span>

        <div ref={listElement} className='flex flex-col w-full h-full'>
          {projectList?.length ? (
            projectList?.map((projectItem, index) => (
              <VisibilitySensor
                partialVisibility={true}
                offset={{ bottom: 5 }}
                key={index}
              >
                {({ isVisible }) =>
                  isVisible ? (
                    <div
                      key={projectItem?.id}
                      className={
                        'flex flex-row px-1 min-h-9 items-center hover:bg-primary-50/5'
                      }
                      onClick={() => handleSelectProject(projectItem?.id)}
                    >
                      <div className='flex flex-row items-center cursor-pointer '>
                        <img
                          src={noteIcon}
                          className='w-[16px] h-[20px]'
                          alt='Note Icon'
                        />
                        <span className='ml-2 text-white text-sm select-none'>
                          {projectItem?.project}{' '}
                          <span className='text-white/60'>{`(${projectItem?.prefix})`}</span>
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div className='h-9' />
                  )
                }
              </VisibilitySensor>
            ))
          ) : (
            <span className='text-sm text-neutral-50 mt-0.5 font-light'>
              {loading ? 'Loading...' : 'No recent projects'}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectsTab;
